jQuery(document).ready(function ($) {

    /**
     * Mobile Menu Toggle
     */
    $(".menu_open").on("click", function () {
        $(".mobile_menu_wrap").toggleClass("menu_show");
        $(".menu_overlay").toggle();
        $("html").toggleClass("overflow-hidden");
        $(".topbar").toggle();
        $(".menu_open .bi-list")
            .toggleClass("bi-x");
    });


    /**
     * Close Menu Events
     */
    $(".menu_close, .menu_overlay, .mobile_menu_wrap ul li a").on("click", function () {
        closeAllMenus();
    });


    /**
     * Add Submenu Controls
     */
    $(".mobile_menu_wrap ul li").each(function () {

        const $submenu = $(this).children("ul");

        if ($submenu.length && $submenu.children("li").length) {

            $(this)
                .addClass("hassub")
                .append(`
                    <a href="javascript:;" class="sub_menu_open">
                        <i class="bi bi-plus"></i>
                    </a>
                `);
        }
    });


    /**
     * Disable Dummy Links
     */
    $(
        "li.hassub a[href='#'], " +
        "li.hassub a[href='javascript:;'], " +
        "li.hassub a[href='javascript:void(0);']"
    ).addClass("no_link");


    /**
     * Open Submenu via Parent Link
     */
    $(".mobile_menu_wrap").on("click", "ul li a.no_link", function (e) {
        e.preventDefault();

        const $submenu = $(this).next("ul");

        $(".menu_open .bi-list").removeClass("bi-x");

        if ($submenu.length) {
            if ($submenu.hasClass("show_submenu")) {
                closeSubmenuAndChildren($submenu);
            } else {
                openSubmenu($submenu);
            }
        }
    });


    /**
     * Back Button
     */
    $(".mobile_menu_wrap").on("click", ".back_to_mainmenu", function () {
        const $submenu = $(this).parent();

        closeSubmenuAndChildren($submenu);
    });


    /**
     * Submenu Toggle Button
     */
    $(".mobile_menu_wrap").on("click", ".sub_menu_open", function (e) {
        e.preventDefault();

        const $submenu = $(this).prev("ul");

        if ($submenu.hasClass("show_submenu")) {
            closeSubmenuAndChildren($submenu);
        } else {
            openSubmenu($submenu);
        }
    });


    /**
     * Close All Menus
     */
    function closeAllMenus() {

        $(".mobile_menu_wrap").removeClass("menu_show");

        $(".menu_overlay").hide();

        $(".mobile_menu_wrap ul li ul")
            .removeClass("show_submenu");

        $("html").removeClass("overflow-hidden");

        $(".sub_menu_open .bi")
            .removeClass("bi-dash")
            .addClass("bi-plus");
    }


    /**
     * Open Submenu
     */
    function openSubmenu($submenu) {

        $submenu.addClass("show_submenu");

        $submenu
            .siblings(".sub_menu_open")
            .find(".bi")
            .removeClass("bi-plus")
            .addClass("bi-dash");
    }


    /**
     * Close Submenu & Child Submenus
     */
    function closeSubmenuAndChildren($submenu) {

        $submenu.removeClass("show_submenu");

        $submenu
            .find("ul.show_submenu")
            .removeClass("show_submenu");

        $submenu
            .find(".sub_menu_open .bi")
            .removeClass("bi-dash")
            .addClass("bi-plus");

        $submenu
            .siblings(".sub_menu_open")
            .find(".bi")
            .removeClass("bi-dash")
            .addClass("bi-plus");
    }

});